import {Button, Image, Loader} from "../../../../../../../components";
import arrowRight from "../../../../../../../assets/images/icons/arrow-right.svg";
import arrowDown from "../../../../../../../assets/images/icons/arrow-down.svg";
import React, {useState} from "react";
import styles from "../DocumentsToProjectsItem.module.scss";
import {ProjectDocumentsAgreement} from "../../../../../../../api-client/models/documents/ProjectDocumentsAgreement";
import {Agreement} from "../../../../../../../api-client/models/documents/Agreement";
import {AgreementType} from "../../../../../../../api-client/enums/AgreementType";
import {AgencyOrder, AgentReport} from "../index";
import {createAgreementProvider} from "../../../../../../../di";
import apiClientConfig from "../../../../../../../configs/app";
import {useErrorCallback, useProfileData} from "../../../../../../../hooks";
import {DocumentScopeType, ProjectStatus, Role} from "../../../../../../../api-client";
import IncomeCertificateModal
  from "../../../../../../../components/common/modals/IncomeCertificateModal/IncomeCertificateModal";
import {DifferentDocument} from "../DifferentDocument";
import {formatDate} from "../../../../../../../formatters";


interface Props {
    projectDocument: ProjectDocumentsAgreement
}

export const DocumentsToProjectItemComponent = ({projectDocument}: Props) => {
  const [loadingUuid, setLoadingUuid] = useState<string | null>(null);
  const [selectedInvestUuid, setSelectedInvestUuid] = useState<string | undefined>();
  const [active, setActive] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const {role} = useProfileData();
  const closeModal = () => {
    setActiveModal(false);
  };
  const handleError = useErrorCallback();
  const downloadAgentReport = async (investUuid?: string) => {
    if (!investUuid) return;
    setLoadingUuid(investUuid);
    try {
      const provider = await createAgreementProvider();
      if (investUuid) {
        const result = await provider.createAgentReport(investUuid);
        window.open(apiClientConfig.apiBaseUrl + result.url, '_blank');
      }
    } catch (error) {
      if (error instanceof Error) {
        await handleError(error);
      }
    } finally {
      setLoadingUuid(null);
    }
  };

  const isPaidLoanPayment = (projectDocument.projectStatus === ProjectStatus.PAID || projectDocument.projectStatus === ProjectStatus.LOAN_PAYMENT);
  const getInvestmentUuid = (document: Agreement) => {
    if (document.investmentUuid) return document.investmentUuid;
    return document.tags.find(tag => tag.objectType === 'investment')?.objectUuid;
  };

  const convertDocumentsToInvestmentUuid = (documents: Agreement[]) => {
    const newGroupDocuments: Record<string, Agreement[]> = {};
    documents.forEach((document: Agreement) => {
      const {investmentUuid} = document;
      if (investmentUuid !== undefined) {
        if (!newGroupDocuments[investmentUuid]) newGroupDocuments[investmentUuid] = [];
        newGroupDocuments[investmentUuid].push(document);
      }
    });
    return newGroupDocuments;
  };
  let agentReportCounter = 0;

  return (
    <>
      <li key={projectDocument.uuid} className={styles.documentsToProjectItemTitle__list}>
        <div className={styles.documentsToProjectItemTitle__item}>
          <p>{projectDocument.projectName ?? "Не указано"}</p>
          {projectDocument.loanIssuedAt && <div>
            <div
              className={styles.documentsToProjectBody__date}>{formatDate(new Date(projectDocument.loanIssuedAt))}</div>
            <div
              className={styles.documentsToProjectBody__dateText}>дата выдачи займа
            </div>
          </div>}
          <Button className={styles.documentsToProjectItemTitle__arrowButton}
            onClick={() => setActive((prevState) => !prevState)}>
            <Image className={styles.documentsToProjectItemTitle__arrowButton__image}
              src={active ? arrowDown : arrowRight}/>
          </Button>
        </div>
      </li>
      {active && <ul className={styles.documentsToProjectBody}>
        {projectDocument.projectDocuments
          ?.filter((document) => {
            if (role === Role.LENDER)
              return document.scope === DocumentScopeType.LENDER || document.scope === DocumentScopeType.COMMON;

            if (role === Role.BORROWER)
              return document.scope === DocumentScopeType.BORROWER || document.scope === DocumentScopeType.COMMON;

            return false;
          })
          .map((document) => (
            <DifferentDocument document={document} key={document.name} />
          ))}
        {projectDocument.documents && Object.values(convertDocumentsToInvestmentUuid(projectDocument.documents)).map((documents: Agreement[], index) => {
          return (<li className={styles.documentsToProjectBody__invest} key={index}>
            {documents.map((document: Agreement) => {
              if (document.type !== AgreementType.PROJECT_ACCEPT) {
                return (
                  <ul className={styles.documentsToProjectBody__investContainer} key={document.uuid}>
                    {(document.type === AgreementType.INVESTMENT_OFFER) &&
                    <AgencyOrder document={document}/>}
                    {(document.type === AgreementType.AUTO_INVESTMENT_SETTINGS) &&
                    <AgencyOrder document={document}/>}
                  </ul>);
              }
            })}
            {documents.map((document: Agreement) => {
              if (document.type !== AgreementType.PROJECT_ACCEPT) {
                if (document.type === AgreementType.PROJECT_REPORT) agentReportCounter++;
                return (
                  <ul className={styles.documentsToProjectBody__investContainer} key={document.uuid}>
                    {(document.type === AgreementType.PROJECT_REPORT) &&
                    <AgentReport document={document} isSupplemented={agentReportCounter > 1}/>}
                  </ul>);
              }
            })}
            
            <ul className={styles.documentsToProjectBody__investContainer}>
              {isPaidLoanPayment &&
              <li
                className={styles.documentsToProjectBody__makeReport && styles.documentsToProjectBody__downloadAgentReport}>
                <Button
                  className={styles.documentsToProjectBody__orderReport}
                  onClick={() => downloadAgentReport(getInvestmentUuid(documents[0]))}
                  disabled={loadingUuid === getInvestmentUuid(documents[0])}>
                  заказать выписку из реестра договоров
                </Button>
              </li>}
              {loadingUuid === getInvestmentUuid(documents[0]) && <Loader/>}

              {isPaidLoanPayment && projectDocument.loanIssuedAt && (new Date().getFullYear() !== new Date(projectDocument.loanIssuedAt).getFullYear()) &&
              <IncomeCertificateModal active={activeModal}
                onClose={closeModal}
                investUuid={selectedInvestUuid}
                startYear={new Date(projectDocument.loanIssuedAt).getFullYear()}/>}
            </ul>
            {isPaidLoanPayment && projectDocument.loanIssuedAt && (new Date().getFullYear() !== new Date(projectDocument.loanIssuedAt).getFullYear()) &&
            <li
              className={styles.documentsToProjectBody__makeReport && styles.documentsToProjectBody__downloadAgentReport}
            >
              <Button
                className={styles.documentsToProjectBody__incomeCertificate}
                onClick={() => {
                  setSelectedInvestUuid(getInvestmentUuid(documents[0]));
                  setActiveModal(true);
                }}>
                заказать справку о доходах
              </Button>
            </li>}
          </li>);
        })}
      </ul>
      }
    </>
  );
};




